<div class="app-loader" [hidden]="!loaderService.isLoaderShow">
    <div class="flex-box">
        <div class="text-center">
            <em class="fa fa-2x fa-spinner fa-spin"></em>
            <span>{{ 'common.messages.please_wait' | transloco }}</span>
        </div>
    </div>
</div>

<div #progressBar class="hidden">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>

<div *ngIf="isConnected">
    <h6 class="internet-warning">
        <em class="fas fa-exclamation-triangle"></em> {{ 'webapp.general.no_internet_connection' | transloco }}
    </h6>
</div>

<app-print-receipt></app-print-receipt>
<router-outlet></router-outlet>
